export const getReactFlowNodes = (workflowNodeDto) => {
  if (!workflowNodeDto) return [];
  const reactFlowNodes = (workflowNodeDto || []).map((nodeDto) => {
    const customNodeData = JSON.parse(nodeDto.customNodeData);
    return {
      data: {
        label: nodeDto.title,
        workflowNodeId: nodeDto.workflowNodeId,
        clientId: nodeDto.clientId,
        title: nodeDto.title,
        description: nodeDto.description,
        ownerTeamId: nodeDto.ownerTeamId,
        duration: nodeDto.duration,
        relationshipTypeValue: nodeDto.relationshipTypeValue || 0,
      },
      // CustomNodeData was stripped of 'data' field at upload, so contents of the 'data' field
      // from above will not be overwritten. But this does include 'id' (same as 'clientId')
      ...customNodeData,
    };
  });

  return reactFlowNodes;
};

export const getReactFlowEdges = (workflowEdgeDto) => {
  if (!workflowEdgeDto) return [];
  const reactFlowEdges = (workflowEdgeDto || []).map((edgeDto) => {
    const customEdgeData = edgeDto.customEdgeData
      ? JSON.parse(edgeDto.customEdgeData)
      : {};
    return {
      workflowEdgeId: edgeDto.workflowEdgeId,
      clientId: edgeDto.clientId,
      source: edgeDto.sourceNodeClientId,
      target: edgeDto.targetNodeClientId,
      ...customEdgeData, // includes 'id'
    };
  });
  return reactFlowEdges;
};

export const mapReactFlowNodesToDto = (reactFlowNodes) => {
  if (!reactFlowNodes) return [];

  const workflowNodeDto = reactFlowNodes.map((node) => {
    // CustomNodeData is all of ReactFlow's node EXCEPT the 'data' filed.
    // The data in 'data' field are mapped at the root level of the parent nodeDto.
    // (but includes 'id', even though it maps to dto's 'ClientId' field.)
    const customNodeData = {};
    for (const nodeField in node) {
      if (nodeField !== "data") customNodeData[nodeField] = node[nodeField];
    }

    return {
      workflowNodeId: node.data.workflowNodeId || 0,
      clientId: node.id,
      title: node.data.label || "",
      description: node.data.description,
      duration: node.data.duration ? +node.data.duration : null,
      ownerTeamId: node.data.ownerTeamId,
      relationshipTypeValue: node.data.relationshipTypeValue || 0,
      customNodeData: JSON.stringify(customNodeData),
    };
  });

  return workflowNodeDto;
};

export const mapReactFlowEdgesToDto = (edges, nodes) => {
  if (!edges || !nodes) return;

  const excludeDtoFields = (edgeData) => {
    // Any field other than listed below are 'custom'
    const dtoFields = [
      "workflowEdgeId",
      "sourceNodeClientId",
      "targetNodeClientId",
      "label",
      "weight",
    ];
    const customEdgeData = {};
    Object.keys(edgeData)
      .filter((e) => !dtoFields.includes(e))
      .forEach((e) => (customEdgeData[e] = edgeData[e]));

    return customEdgeData;
  };

  const workflowEdgeDtos = (edges || []).map((e) => {
    return {
      workflowEdgeId: e.workflowEdgeId || 0,
      clientId: e.id,
      sourceNodeClientId: e.source,
      targetNodeClientId: e.target,
      label: e.label || "",
      weight: e.weight || 0,
      customEdgeData: JSON.stringify(excludeDtoFields(e)),
    };
  });

  return workflowEdgeDtos;
};
